import { render, staticRenderFns } from "./NewCampaignStatusNotification.vue?vue&type=template&id=686f45c2&scoped=true"
import script from "./NewCampaignStatusNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCampaignStatusNotification.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewCampaignStatusNotification.vue?vue&type=style&index=0&id=686f45c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f45c2",
  null
  
)

export default component.exports